module.exports = __webpack_public_path__ + "static/media/food-and-restaurant3.12a187ee.png";